/**
 * Кешовете, които service worker-ът пълнеше до TASK_42 (23.09.2026) с отговори
 * на Firestore и `*.firebaseapp.com`. Маршрутите им са махнати (`pwaOptions.ts`),
 * но Cache Storage на устройството ги пази, докато някой не ги изтрие — а в
 * `firestore-cache` стоят документи на семейството, и то след изход от акаунта.
 *
 * Само тези две имена. Precache-ът на workbox остава: без него всяко отваряне
 * тегли приложението наново.
 */
export const LEGACY_RUNTIME_CACHES = ['firestore-cache', 'firebase-cache'] as const;

/**
 * Изтрива заварените кешове. Вика се при всеки старт: идемпотентно е, а
 * провалът не чупи старта.
 *
 * ⚠️ Докато страницата още работи под СТАРИЯ service worker (първото отваряне
 * след обновяването), той създава `firestore-cache` наново. Затова чистенето е
 * при всеки старт, не еднократно.
 *
 * @returns имената, които наистина са били изтрити
 */
export async function purgeLegacyRuntimeCaches(cacheStorage?: CacheStorage): Promise<string[]> {
  try {
    // Самото четене на `caches` може да хвърли (непрозрачен произход, напр.
    // sandbox iframe) — затова е вътре в try, не в стойност по подразбиране.
    const storage = cacheStorage ?? globalThis.caches;
    // `caches` липсва извън защитен контекст (http) — тогава няма и какво да се чисти.
    if (!storage) return [];

    const deleted = await Promise.all(
      LEGACY_RUNTIME_CACHES.map((name) => storage.delete(name)),
    );
    return LEGACY_RUNTIME_CACHES.filter((_, i) => deleted[i]);
  } catch (error) {
    console.warn('Legacy service worker caches could not be purged:', error);
    return [];
  }
}
